/**
 * Factory functions for LexicalTextEditor handlers
 */
import { updateTextAndSelectedText } from "../utils/stateUpdateUtils";

/**
 * Create handlers for LexicalTextEditor (content, task, note)
 */
export const createLexicalEditorHandlers = ({
  field,
  textId,
  setTexts,
  setSelectedText,
  saveToHistory,
  shouldSaveHistory = true,
  setPendingChanges,
  isElementBeingEdited,
}) => {
  const fieldName = field === "content" ? "" : field; // content has no prefix
  const contentField = field;
  const plainTextField = `${field}PlainText`;
  const isHtmlField = `${field}IsHtml`;

  return {
    onContentChange: (htmlContent, plainText) => {
      const cleanedContent = htmlContent.replace(/&nbsp;/g, " ");
      const isHtml = /<\/?[a-z][\s\S]*?>/i.test(cleanedContent);


      // CRITICAL: Mark that there are pending changes so history will be saved on unselection
      if (isElementBeingEdited && typeof setPendingChanges === "function") {
        setPendingChanges(true);
      } else {
      }

      const updates = {
        [contentField]: cleanedContent,
        [plainTextField]: plainText,
        [isHtmlField]: plainText ? isHtml : false,
        _lastUpdated: Date.now(),
      };

      updateTextAndSelectedText({
        textId,
        setTexts,
        setSelectedText,
        updates,
      });
    },

    onColorChange: (newColor) => {
      const colorField = `${field}Color`;
      updateTextAndSelectedText({
        textId,
        setTexts,
        setSelectedText,
        updates: {
          [colorField]: newColor,
          _lastUpdated: Date.now(),
        },
      });
      if (shouldSaveHistory) saveToHistory();
    },

    onUnderlineChange: () => {
      const underlineField = `${field}Underline`;
      setTexts((prev) =>
        prev.map((t) =>
          t.id === textId
            ? {
              ...t,
              [underlineField]: !t[underlineField],
              _lastUpdated: Date.now(),
            }
            : t
        )
      );
      setSelectedText((prev) =>
        prev
          ? {
            ...prev,
            [underlineField]: !prev[underlineField],
            _lastUpdated: Date.now(),
          }
          : prev
      );
      if (shouldSaveHistory) saveToHistory();
    },

    onHighlightChange: () => {
      const highlightField =
        field === "content" ? "contentHighlight" : `${field}Highlighted`;
      setTexts((prev) =>
        prev.map((t) =>
          t.id === textId
            ? {
              ...t,
              [highlightField]: !t[highlightField],
              _lastUpdated: Date.now(),
            }
            : t
        )
      );
      setSelectedText((prev) =>
        prev
          ? {
            ...prev,
            [highlightField]: !prev[highlightField],
            _lastUpdated: Date.now(),
          }
          : prev
      );
      if (shouldSaveHistory) saveToHistory();
    },

    onNumberedList: () => {
      updateTextAndSelectedText({
        textId,
        setTexts,
        setSelectedText,
        updates: { _lastUpdated: Date.now() },
      });
      if (shouldSaveHistory) saveToHistory();
    },

    onBulletedList: () => {
      updateTextAndSelectedText({
        textId,
        setTexts,
        setSelectedText,
        updates: { _lastUpdated: Date.now() },
      });
      if (shouldSaveHistory) saveToHistory();
    },

    onLinkChange: () => {
      const linkField = `${field}Link`;
      updateTextAndSelectedText({
        textId,
        setTexts,
        setSelectedText,
        updates: {
          [linkField]: true,
          _lastUpdated: Date.now(),
        },
      });
      if (shouldSaveHistory) saveToHistory();
    },
  };
};
